// Durable (localStorage) draft of unsaved "Add Items" work, keyed per estimate.
// localStorage (not sessionStorage) so it survives the installed PWA being
// killed and reopened, not just an in-place reload.
const KEY = (jobId) => `techAddItemDraft:v2:${jobId}`;
const MAX_AGE_MS = 14 * 24 * 3600 * 1000;

export const newClientId = () =>
  `c${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;

export function loadDraft(jobId, store = globalThis.localStorage) {
  try {
    const raw = store.getItem(KEY(jobId));
    if (!raw) return null;
    const d = JSON.parse(raw);
    if (!d || typeof d !== 'object') return null;
    if (d.ts && Date.now() - d.ts > MAX_AGE_MS) { store.removeItem(KEY(jobId)); return null; }
    return d;
  } catch { return null; }
}

export function clearDraft(jobId, store = globalThis.localStorage) {
  try { store.removeItem(KEY(jobId)); } catch { /* ignore */ }
}

// Returns true if something was persisted. Falls back to dropping photo
// previews (large base64) if the quota is exceeded, so items are never lost
// just because a photo is big.
export function saveDraft(jobId, draft, store = globalThis.localStorage) {
  const payload = { ...draft, ts: Date.now() };
  try { store.setItem(KEY(jobId), JSON.stringify(payload)); return true; } catch { /* quota */ }
  try {
    const slim = (payload.unsavedItems || []).map(({ _photos, ...r }) => r); // eslint-disable-line no-unused-vars
    store.setItem(KEY(jobId), JSON.stringify({ ...payload, unsavedItems: slim, photoPreview: null, afterPhotoPreview: null, photosDropped: true }));
    return true;
  } catch { return false; }
}

export function hasContent(d) {
  return !!(d && ((d.unsavedItems && d.unsavedItems.length) || d.selectedItem || d.photoPreview || d.afterPhotoPreview));
}

// Client-only fields on a row start with "_" (_cid, _sync, _photos, ...).
// Strip them before sending to ERP.
export function toServerItem(it) {
  return Object.fromEntries(Object.entries(it).filter(([k]) => !k.startsWith('_')));
}

// A row is durable-pending until the server confirmed it.
export const isPending = (r) => r._sync && r._sync !== 'saved';
